import { Send, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { Squiggle, MicrophoneDoodle } from "./doodles";
import { STATION } from "@/config/station";

export default function SubmitMusic() {
    return (
        <section
            id="submit-music"
            data-testid="artist-submissions-section"
            className="border-b-[2.5px] border-ink bg-skylight py-16 sm:py-24"
        >
            <div className="mx-auto max-w-3xl px-4 text-center sm:px-6">
                <Reveal>
                    <span className="sticker bg-sky text-white">06 · The Crates</span>
                    <h2 className="mt-4 font-condensed text-3xl font-black uppercase tracking-tight text-ink sm:text-4xl lg:text-5xl">
                        Got Heat? Let Us Hear It.
                    </h2>
                    <Squiggle className="mx-auto mt-3 h-3 w-36" stroke="#1A1918" />
                    <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-ink2 sm:text-lg">
                        Making music? Send it our way. We're here to discover new sounds and connect
                        with independent artists. Drop your track, tell us who you are, and let the
                        music speak.
                    </p>
                </Reveal>

                <Reveal delay={0.15}>
                    <div className="card-hard mx-auto mt-10 max-w-xl bg-cream p-6 sm:p-10">
                        <div className="flex items-center justify-center gap-4">
                            <MicrophoneDoodle className="h-20 w-20 shrink-0" />
                            <p className="-rotate-1 text-left font-hand text-2xl font-bold leading-tight text-ink2">
                                free to submit. no accounts. no catch.
                            </p>
                        </div>
                        <a
                            data-testid="button-submit-music"
                            href={STATION.musicSubmissionFormUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn-ink mt-8 w-full bg-sunny text-xl hover:bg-sunnyhover"
                        >
                            <Send className="h-5 w-5" strokeWidth={2.5} />
                            Send My Music
                            <ArrowUpRight className="h-5 w-5" strokeWidth={2.5} />
                        </a>
                        <p className="mt-4 font-mono2 text-xs leading-relaxed text-ink2">
                            Takes you to our official submission form — opens in a new tab.
                        </p>
                        <p
                            data-testid="submission-disclaimer"
                            className="mt-3 text-sm leading-relaxed text-ink2"
                        >
                            All styles and independent artists are welcome. Submissions are reviewed,
                            but airplay is not guaranteed.
                        </p>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
